import { mdpOublie, changerMdp } from '@/api/utilisateurAnnonyme/index';

export async function requestReinitPwdCode(payload) {
  const response = await mdpOublie(payload);
  return response.data.result;
}

export async function resetPassword(payload) {
  const response = await changerMdp(payload);
  return response.data.result;
}
